export default __webpack_public_path__ + "static/media/16.a5d1b4f5.png";